import React from "react"
import PropTypes from "prop-types"
import SettingsSectionCard from "@modules/ui/components/SettingsSectionCard"

import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"

const propTypes = {
  id: PropTypes.oneOf(Object.values(SiteSettingsSection)).isRequired,
  renderTitle: PropTypes.func,
  children: PropTypes.node,
}

const defaultRenderTitle = defaultTitle => defaultTitle

export default function SiteSettingsSectionCard({
  id,
  renderTitle = defaultRenderTitle,
  ...rest
}) {
  return (
    <SettingsSectionCard
      id={id}
      title={renderTitle(SiteSettingsSectionLabel[id])}
      {...rest}
    />
  )
}

SiteSettingsSectionCard.propTypes = propTypes
